import React from "react";
import { Box } from "@mui/material";

const ImageButton = ({
  url,
  imageSrc,
  label,
  width = 80,
  sx = {},
}) => {
  return (
    <Box
      component="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      sx={{
        display: "inline-block",
        cursor: "pointer",
        transition: "transform 0.2s ease",

        "&:hover": {
          transform: "scale(1.05)",
        },

        ...sx,
      }}
    >
      <Box
        component="img"
        src={imageSrc}
        alt={label}
        sx={{
          width,
          display: "block",
        }}
      />
    </Box>
  );
};

export default ImageButton;